export const TEST_IDS = {
	RuleNameInput: 'rule-name-input',
	RuleTypeInput: 'rule-type-input',
	EnableFallbackCheckbox: 'enable-fallback-checkbox',
	FallbackMethodsRadioInput: 'fallback-methods-radio-input',
	ReadOnlyMessage: 'read-only-message',
	CloseReadOnlyMessage: 'close-read-only-message',
	RuleTypeWarningMessage: 'rule-type-warning-message'
};
